import { render, staticRenderFns } from "./view-modal-iframe.vue?vue&type=template&id=402d4bb6"
import script from "./view-modal-iframe.vue?vue&type=script&lang=js"
export * from "./view-modal-iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports